const apis = {
  getDevParams: {
    url: '/api/machine/param',
    name: 'GET_DEV_PARAM',
  },
};

export default apis;
